import { ReactElement } from 'react';

const TelegramIcon = (props: TClassNameProps): ReactElement => (
	<svg width="20" height="17" viewBox="0 0 20 17" fill="none" {...props}>
		<path
			d="M18.2949 0.146745C18.2949 0.146745 20.1451 -0.572756 19.9909 1.1746C19.9395 1.89411 19.4769 4.41236 19.1172 7.13618L17.8838 15.2049C17.8838 15.2049 17.781 16.3869 16.8559 16.5925C15.9308 16.7981 14.5432 15.873 14.2863 15.6674C14.0807 15.5132 10.4318 13.2006 9.14696 12.0699C8.78721 11.7615 8.37607 11.1448 9.19836 10.4253L14.5946 5.28604C15.2113 4.66932 15.828 3.23032 13.2584 4.97768L6.06339 9.86001C6.06339 9.86001 5.2411 10.3739 3.69931 9.9114L0.358771 8.88354C0.358771 8.88354 -0.874659 8.11265 1.23245 7.34176C6.37174 4.92629 12.6931 2.45943 18.2949 0.146745Z"
			fill="currentColor"
		/>
	</svg>
);

export default TelegramIcon;
